import React from 'react';

const Vision = () => {
    return (
        <main className="min-h-screen bg-[#050914] text-white">

            <section className="pt-36 pb-28">
                <div className="max-w-[1200px] mx-auto px-8">

                    <div className="flex items-center gap-3 text-[11px] tracking-[0.28em] text-neutral-500 mb-7">
                        <span className="w-8 h-px bg-neutral-600" />
                        VISION
                    </div>

                    <h1 className="max-w-[1000px] text-[48px] sm:text-[64px] lg:text-[76px] leading-[1] font-semibold tracking-[-0.045em]">
                        The next generation of wearables
                        <br />
                        <span className="text-neutral-500">
              won't just sense you.
            </span>
                        <br />
                        They'll understand you.
                    </h1>

                    <p className="mt-8 max-w-[720px] text-[17px] leading-[1.7] text-neutral-400">
                        Our long-term vision is a personalized intelligence layer that
                        combines brain, physiological and behavioral signals to help
                        everyday devices respond to cognitive context.
                    </p>

                </div>
            </section>

            <section className="border-t border-white/10 py-28">
                <div className="max-w-[1200px] mx-auto px-8">

                    <div className="grid md:grid-cols-3 gap-5">

                        <div className="rounded-[28px] border border-white/10 bg-white/[0.02] p-8">
                            <div className="text-[11px] tracking-[0.22em] text-neutral-600">
                                BRAIN
                            </div>

                            <h2 className="mt-8 text-[25px] font-medium">
                                EEG
                            </h2>

                            <p className="mt-4 text-[14px] leading-7 text-neutral-500">
                                Neural signals provide a foundation for understanding changes
                                in cognitive state.
                            </p>
                        </div>

                        <div className="rounded-[28px] border border-white/10 bg-white/[0.02] p-8">
                            <div className="text-[11px] tracking-[0.22em] text-neutral-600">
                                BODY
                            </div>

                            <h2 className="mt-8 text-[25px] font-medium">
                                Physiology
                            </h2>

                            <p className="mt-4 text-[14px] leading-7 text-neutral-500">
                                Heart, movement, sleep and other signals provide additional
                                context around the person.
                            </p>
                        </div>

                        <div className="rounded-[28px] border border-[#8ea5ff]/20 bg-[#10162a] p-8">
                            <div className="text-[11px] tracking-[0.22em] text-[#8ea5ff]">
                                INTELLIGENCE
                            </div>

                            <h2 className="mt-8 text-[25px] font-medium">
                                Personalization
                            </h2>

                            <p className="mt-4 text-[14px] leading-7 text-neutral-500">
                                The long-term goal is a system that understands patterns in
                                the individual rather than treating every user the same.
                            </p>
                        </div>

                    </div>

                </div>
            </section>

        </main>
    );
};

export default Vision;